import { ApiClient } from '../redux/models/src';
import packageJson from '/package.json';

const ENV = 'test';
const API_URL = 'https://backoffice.service.test.perplay.io/';
const API_CLIENT = new ApiClient(API_URL);
const SESSION_EXPIRATION_TIME = 1000 * 60 * 60;
const SESSION_ALARM_TIME = 1000 * 60;
const VERSION = `${packageJson.version} TEST`;

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCqrIEr_M_JYt_xC5P1GvFQL4mi4YMuvl0',
  authDomain: 'perplaydev.firebaseapp.com',
  databaseURL: 'https://perplaydev-default-rtdb.firebaseio.com',
  projectId: 'perplaydev',
  storageBucket: 'perplaydev.appspot.com',
  messagingSenderId: '353016630653',
  appId: '1:353016630653:web:af54d7f77a4d4de8be1014',
  measurementId: 'G-5M8SYE6D1S',
};

const TOKEN_CONTRACT_ADDRESS = {
  xper: '0x5dE38589a58e5244a41a97550EC8E81aDB8fFEB7',
  per: '0xeE5210e0B55352B0a8956448Bc60Eb3C386Da052',
  arb: '0xE3AeEb6172327BEcFbd30d797cEA5B954b24Adf4',
  nft: '0x4c99346f3E4d25D73DE0B585816F23592b79655D',
};

const PAGE_OPTION_URL =
  'https://script.google.com/macros/s/AKfycbxOUO_bjbnaNYz6sUux03YTLNtkJ6foiwKZ8-7yuBFVI28BWmm9Q_iZbgFqTUsF7wDleQ/exec';

const STRING_TABLE_URL =
  'https://script.google.com/macros/s/AKfycbwuTr1fFHhcCNU-HGRE1dd03Jmd4BtHKZmsvoNHTjCYUkqFVH0voRwKw_uWpqAcwO5YWg/exec';

const BACK_OFFICE_STRING_TABLE_URL =
  'https://script.google.com/macros/s/AKfycbxpKSRfrJr9VsZZ7Ncbv_L9diWTnRYevSEGC9vZWLtm5d1NX3WpLz4FBesCbUqwUcUHYw/exec';

const HVH_NETWORK_URL ='https://ctz.vega.havah.io/api/v3';

const BRIDGE_API_URL = 'https://perflex-stage.perflex.io';

// Arbitrum 체인 파라미터 설정
const ARBITRUM_CHAIN = {
  chainId: 421614,
  chainName: 'Arbitrum Sepolia',
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
  rpcUrls: ['https://sepolia-rollup.arbitrum.io/rpc'],
  blockExplorerUrls: ['https://sepolia.arbiscan.io/'],
};

const TEST_CONFIG = {
  API_URL,
  API_CLIENT,
  SESSION_EXPIRATION_TIME,
  SESSION_ALARM_TIME,
  FIREBASE_CONFIG,
  TOKEN_CONTRACT_ADDRESS,
  VERSION,
  ENV,
  PAGE_OPTION_URL,
  STRING_TABLE_URL,
  BACK_OFFICE_STRING_TABLE_URL,
  HVH_NETWORK_URL,
  BRIDGE_API_URL,
  ARBITRUM_CHAIN
};
export default TEST_CONFIG;
